import React from "react";
import Hero from "./Hero";
import AsFeaturedIn from "./AsFeaturedIn";
import MainFeature from "./MainFeature";
import SmarterSteps from "./SmarterSteps";
import MobileApp from "./MobileApp";
import BringingTech from "./BringingTech";
import Testimonials from "./Testimonials";
import InTheNews from "./InTheNews";
import Partners from "./Partners";

/**
 * Section grounds alternate deliberately — dark, white, paper, white,
 * paperDeep, dark, white, paper, paperDeep, dark(footer) — so no two
 * neighbours share a ground and the two dark bands anchor the page.
 */
export default function Home() {
  return (
    <main>
      <Hero />
      <AsFeaturedIn />
      <MainFeature />
      <SmarterSteps />
      <MobileApp />
      <BringingTech />
      <Testimonials />
      <InTheNews />
      <Partners />
    </main>
  );
}
